import styled from 'styled-components';

export const PopupContainer = styled.div`
  div {
    position: unset !important;
    animation-duration: 0s !important;
  }

  .ant-picker-panel {
    border: none !important;
  }

  .ant-picker-panel-container {
    display: block;
    box-shadow: none !important;

    & > div:nth-child(1) {
      max-width: 100%;
      position: unset !important;
    }

    .ant-picker-body {
      padding: 8px !important;
    }
  }

  .ant-picker-panel .ant-picker-footer {
    border: none !important;
  }
`;
